export default function image64(img, callback, output) {
  // console.log("droppedImg", img);
  let image = new Image();
  image.crossOrigin = "Anonymous";
  if (output == "image/svg+xml") {
    let svgAsXML = new XMLSerializer().serializeToString(img);
    image.src =
      "data:image/svg+xml," +
      encodeURIComponent(svgAsXML).replace(
        "style%3D%22display%3A%20none%3B%22",
        "style%3D%22shape-rendering%3AgeometricPrecision%3B%20text-rendering%3AgeometricPrecision%3B%20image-rendering%3AoptimizeQuality%3B%20fill-rule%3Aevenodd%3B%20clip-rule%3Aevenodd%3B%22"
      );
    // image.src = "data:image/svg+xml;base64," + window.btoa(svgAsXML);
    // image.src = "data:image/svg+xml;charset=utf-8," + svgAsXML;
    // console.log(image.src);
    callback(image.src);
  } else {
    image.onload = function () {
      // console.log("test");
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      let dataURL;
      canvas.height = image.naturalHeight;
      canvas.width = image.naturalWidth;
      ctx.drawImage(image, 0, 0);
      dataURL = canvas.toDataURL(output);
      // console.log(dataURL);
      callback(dataURL);
    };
    image.src = img;
    if (image.complete || image.complete === undefined) {
      image.src =
        "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
      image.src = img;
    }
  }
}
